/**
 * 打印补全pdfUrl, 当产生的url无http/https协议部分时，默认按pasorepport的打印接口补全。
 */
export function completingUrl(printUrl) {
    if (!printUrl.startsWith("http://") && !printUrl.startsWith("https://")) {
      let baseUrl = window.g_configs.API_SERVER + `/iwms-account/account`;
      if (printUrl.startsWith("/")) {
        printUrl = baseUrl + printUrl;
      } else {
        printUrl = baseUrl + "/" + printUrl;
      }
    }
    return printUrl;
}